import { Configuration } from './api/configuration';

export function apiConfigFactory() {
  return new Configuration({
    basePath: document.location.origin,
    withCredentials: true,
  });
}
